module.exports = __webpack_public_path__ + "static/media/button-click.9a30016e.mp3";